import Container from '@mui/material/Container';

import { BrowserRouter } from "react-router-dom"
import Header from "./layout/Header"
import Footer from "./layout/Footer"
import MainRouter from "./layout/MainRouter"
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import jsiTheme from './theme/jsiTheme'
import SessionTimeout from "./session/SessionTimeout";

function App() {
    return (
        <BrowserRouter>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={jsiTheme}>
                    <Container maxWidth={false} style={{padding: '0'}} sx={{display: 'flex', flexDirection: 'column', minHeight: '98vh', width: '100%', margin: '0'}}>
                        <Header />
                        <SessionTimeout  />
                        <Container maxWidth={false} style={{height: 'auto', padding: '0 5vw .5rem 5vw'}}>
                            <MainRouter />
                        </Container>
                        <Footer />
                    </Container>
                </ThemeProvider>
            </StyledEngineProvider>
        </BrowserRouter>
    );
}

export default App
